import { Alert, Button } from '@indipia/ui-core'
import type { HolidayStatus } from '../../hooks/useHolidays'
// 날짜 이동 안내 — 공휴일 조회 실패(계산·저장 차단 + 다시 시도, A-08) · 저장 응답의 발주·입고 동반 이동 경고(A-16)
// · 공사완료 마커 변경 응답의 정보 문구(결정 51 C-1·C-2, 차단 없음)

export type GanttDateAlertsProps = {
  holidayStatus: HolidayStatus
  onHolidayRetry: () => void
  /** 저장 응답의 동반 이동 경고 문구(없으면 null) */
  orderNotice: string | null
  onOrderNoticeClose: () => void
  /** 마커 변경 응답 warnings 의 정보 한 줄(없으면 null) */
  markerNotice?: string | null
  onMarkerNoticeClose?: () => void
  /** 발주 정보 조회 실패(E-36) — 발주·입고 영역만 오류 안내, 간트는 그대로 */
  ordersFailed?: boolean
  onOrdersRetry?: () => void
}

export function GanttDateAlerts({ holidayStatus, onHolidayRetry, orderNotice, onOrderNoticeClose, markerNotice, onMarkerNoticeClose, ordersFailed, onOrdersRetry }: GanttDateAlertsProps) {
  if (holidayStatus !== 'error' && !orderNotice && !markerNotice && !ordersFailed) return null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--num-8)', padding: 'var(--num-8) var(--num-16) 0', flexShrink: 0 }}>
      {holidayStatus === 'error' && (
        <Alert
          kind="error"
          action={<Button variant="secondary" size="sm" onClick={onHolidayRetry}>다시 시도</Button>}
        >
          공휴일 정보를 불러오지 못했어요 · 다시 시도하기 전에는 날짜를 옮기거나 저장할 수 없어요
        </Alert>
      )}
      {ordersFailed && (
        <Alert
          kind="error"
          role="alert"
          action={onOrdersRetry && <Button variant="secondary" size="sm" onClick={onOrdersRetry}>다시 시도</Button>}
        >
          발주 정보를 불러오지 못했어요 · 발주·입고 표시만 빠져 있고 공종 일정은 그대로 볼 수 있어요
        </Alert>
      )}
      {orderNotice && (
        <Alert kind="warning" onClose={onOrderNoticeClose}>
          {orderNotice}
        </Alert>
      )}
      {markerNotice && (
        <Alert kind="info" onClose={onMarkerNoticeClose}>
          {markerNotice}
        </Alert>
      )}
    </div>
  )
}
